import React, { useEffect, useState } from 'react'

import { IconTurnPhone } from '@avantstay/backoffice-vectors'

import { useIsMobilePortrait } from '../../utils'
import { Button } from '../Button'
import * as S from './MobilePortraitWarning.styles'

export const MobilePortraitWarning = () => {
  const [isShowingWarning, setIsShowingWarning] = useState(true)

  const isMobilePortrait = useIsMobilePortrait()

  useEffect(() => setIsShowingWarning(true), [isMobilePortrait])

  if (!isMobilePortrait || !isShowingWarning) {
    return <></>
  }

  return (
    <S.SlidingDrawerStyled hideCloseButton>
      <S.WarningContainer>
        <IconTurnPhone />
        <S.WarningTitle>Please, turn your device</S.WarningTitle>
        <S.WarningText>Turn your device into landscape mode for better experience.</S.WarningText>
        <Button.Primary type="button" onClick={() => setIsShowingWarning(false)}>
          Ok, got it
        </Button.Primary>
      </S.WarningContainer>
    </S.SlidingDrawerStyled>
  )
}
